import Button from '@zenbusiness/zui/Button';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import useBreakpoints from '#client/hooks/useBreakpoints';

import { BannerWrapper, BannerCard, BannerImage, DividerStyled, BannerAction } from './styles';

const BENEFITS = [
  {
    title: 'Keeps you protected',
    description: 'An LLC protects personal assets. A bank account helps ensure that protection.'
  },
  {
    title: 'Separates your finances',
    description: 'Keep track of the money flowing in and out of your business.'
  },
  {
    title: 'Makes tax filing easy',
    description: 'Separating personal and business finances helps streamline your tax filing.'
  }
];

export const Banner = ({ handleScroll }) => {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();
  return (
    <BannerWrapper
      padding={isDesktop ? 3 : 2}
      spacing={isDesktop ? 4 : 3}
      sx={{
        borderRadius: isDesktop ? 3 : 0,
        boxShadow: isDesktop
          ? '0px 1px 2px 0px rgba(15, 22, 28, 0.04), 0px 1.5px 3px -0.5px rgba(15, 22, 28, 0.08)'
          : 'none'
      }}
    >
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        justifyContent="space-between"
        spacing={isDesktop ? 0 : 2}
      >
        <Text
          color="primary"
          family="secondary"
          size="2xl"
          weight="medium"
        >
          Business Banking Accounts
        </Text>
        <Stack
          spacing={2}
          width={isDesktop ? '50%' : '100%'}
        >
          <Text
            color="secondary"
            size={isDesktop ? 'md' : 'sm'}
          >
            Separate your business finances and stay protected with our Banking solutions.
          </Text>
        </Stack>
      </Stack>

      <Stack
        alignItems="center"
        direction={isDesktop ? 'row' : 'column'}
        position="relative"
        spacing={isDesktop ? 0 : 3}
      >
        <Stack width={isDesktop ? '70%' : '100%'}>
          <BannerImage
            alt="Upsell image"
            src="/s2/raster/banking-hero-image.png"
            sx={{
              transform: isDesktop ? 'scaleX(1)' : 'scaleX(-1)',
              maxHeight: isDesktop ? 330 : 250
            }}
          />
        </Stack>
        <BannerCard
          boxShadow={1}
          padding={2}
          sx={{
            position: isDesktop ? 'absolute' : 'relative',
            width: isDesktop ? '50%' : '100%'
          }}
        >
          <Text
            color="primary"
            size={isDesktop ? 'md' : 'sm'}
            weight="medium"
          >
            Business Banking Benefits
          </Text>
          <DividerStyled />
          <Stack spacing={1}>
            {BENEFITS.map((benefit) => (
              <Stack
                alignItems="center"
                direction="row"
                key={benefit.title}
                spacing={1}
              >
                <SharedAsset
                  alt="checkrounded icon"
                  color="success.main"
                  flex="none"
                  src="/s2/material-icons/checkrounded.svg"
                  width={16}
                />
                <Text size={isDesktop ? 'sm' : 'xs'}>
                  <Text
                    component="span"
                    fontWeight="medium"
                  >
                    {benefit.title}:{' '}
                  </Text>
                  <Text component="span">{benefit.description}</Text>
                </Text>
              </Stack>
            ))}
          </Stack>
          <BannerAction>
            <Button
              color="primary"
              fullWidth
              onClick={handleScroll}
              variant="contained"
            >
              <Text size={isDesktop ? 'md' : 'xs'}>View Banking options</Text>
            </Button>
          </BannerAction>
        </BannerCard>
      </Stack>
    </BannerWrapper>
  );
};

Banner.propTypes = {
  handleScroll: PropTypes.func
};
